import _axios from '../util/axios/AxiosConfig'

export function getSysConfig(){
  return _axios({
    url: '/api/ERPCommon/getSysConfig',
    method: 'get'
  })
}